import { useCallback, useMemo } from "react";
import { useCookies } from "react-cookie";
import { cookieSetOptions } from "../cookieSetOptions";
import { IMPERSONATING_USERNAME_COOKIE } from "./constants";

export const useImpersonationCookie = () => {
  const [cookies, setCookie, removeCookie] = useCookies([IMPERSONATING_USERNAME_COOKIE]);
  const cookieOptions = cookieSetOptions();

  const impersonatingUsername = useMemo(() => {
    const region = cookies[IMPERSONATING_USERNAME_COOKIE];
    if (!region) {
      return undefined;
    }
    return region as string;
  }, [cookies]);

  const setImpersonatingUsernameCookie = useCallback(
    (value: string) => {
      setCookie(IMPERSONATING_USERNAME_COOKIE, value, cookieOptions);
    },
    [cookieOptions, setCookie]
  );

  const removeImpersonatingUsernameCookie = useCallback(() => {
    removeCookie(IMPERSONATING_USERNAME_COOKIE, cookieOptions);
  }, [cookieOptions, removeCookie]);

  return {
    impersonatingUsername,
    setImpersonatingUsernameCookie,
    removeImpersonatingUsernameCookie,
  };
};
